import styled from "@emotion/styled"
import { Button, IconButton, Menu, MenuItem, Typography } from "@mui/material"
import { useState } from "react"
import { Link, usePathname } from "utils"
import { Desktop } from "../../common/bit/MediaQueries"
import ArrowDown from "../../icons/ArrowDown"
import ArrowUp from "../../icons/ArrowUp"
import Language from "../../icons/Language"
import { sharedColors } from "../../theme/colors"
import { StyledIconButton } from "./ContactMenu"

const MenuButton = styled(Button)`
  background-color: transparent;
  padding: 0;
  margin: 0;
  min-width: 0;
  /* height: 40px; */
  height: 100%;
  border-radius: 0;
  padding: 0 !important;
  & .MuiTypography-root::before {
    display: block;
    content: attr(data-content);
    font-weight: 500;
    height: 0;
    overflow: hidden;
    visibility: hidden;
  }
  &:focus-visible {
    border: 1px dashed white;
    outline-offset: 2px;
    outline: 2px solid black;
  }
`

const ButtonInner = styled("div", {
  shouldForwardProp: (prop: string) => prop !== "isOpen",
})<{ isOpen: boolean }>`
  height: 40px;
  display: flex;
  ${({ isOpen }) =>
    isOpen && `box-shadow: inset 0 -2px 0 ${sharedColors.brandDark};`}
  :hover {
    box-shadow: inset 0 -2px 0 ${sharedColors.brandDark};
  }
  align-items: center;
  gap: 4px;
`

const StyledLink = styled(Link, {
  shouldForwardProp: (prop: string) => prop !== "active",
})<{ active: boolean }>`
  text-decoration: none;
  width: 100%;
  padding: 16px 8px;
  color: ${sharedColors.black};
  ${({ active }) => active && `font-weight: 700;`}
`

const OuterIconButton = styled(IconButton)`
  height: 100%;
  padding: 0;
  ${({ theme }) => theme.breakpoints.up("md")} {
    display: none;
  }
`

const StyledMenu = styled(Menu)`
  ${({ theme }) => theme.breakpoints.up("md")} {
    transform: translateX(-18px) !important;
  }
`

export default function LanguageMenu({ locale }: { locale: string }) {
  const [isOpen, setIsOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const pathname = usePathname()

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setIsOpen(true)
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setIsOpen(false)
    setAnchorEl(null)
  }

  const items = [
    {
      label: "עברית",
      locale: "he",
    },
    {
      label: "English",
      locale: "en",
    },
    {
      label: "Русский",
      locale: "ru",
    },
    {
      label: "العربية",
      locale: "ar",
    },
  ]

  return (
    <>
      <Desktop height="100%">
        <MenuButton
          variant="text"
          disableRipple
          onClick={handleClick}
          aria-controls={isOpen ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={isOpen ? "true" : undefined}
        >
          <ButtonInner isOpen={isOpen}>
            <Typography
              variant="body2"
              fontWeight={isOpen ? 500 : 400}
              component={"p"}
              data-content={"עברית"}
            >
              {items.find((item) => item.locale === locale)?.label}
            </Typography>
            {isOpen ? <ArrowUp /> : <ArrowDown />}
          </ButtonInner>
        </MenuButton>
      </Desktop>
      {/* <Mobile height="100%"> */}
      <OuterIconButton onClick={handleClick} disableRipple>
        <StyledIconButton tabIndex={-1} active={isOpen}>
          <Language />
        </StyledIconButton>
      </OuterIconButton>
      {/* </Mobile> */}
      <StyledMenu
        anchorEl={anchorEl}
        open={isOpen}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        sx={{
          "& .MuiMenu-list": {
            padding: "0 8px",
          },
          "& .MuiPaper-root": {
            padding: 0,
            boxShadow: "0px 4px 12px 0px rgba(0, 0, 0, 0.16)",
          },
          "& .MuiMenuItem-root": {
            "&:not(:last-child)": {
              borderBottom: "1px solid #D1D5DB",
            },
          },
          zIndex: 102,
        }}
      >
        {items.map((item) => (
          <MenuItem key={item.label} onClick={handleClose}>
            <StyledLink
              href={pathname}
              locale={item.locale}
              active={locale === item.locale}
            >
              {item.label}
            </StyledLink>
          </MenuItem>
        ))}
      </StyledMenu>
    </>
  )
}
